import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import React from 'react'
import styled from 'styled-components'
import CartReviewTileBase from './_CartReviewTileBase'
import { rem } from 'polished'
import { tileDesktopLayout } from './constants'

const Image = styled(LoadingBox)`
  grid-area: image;
  width: ${rem(64)};
  height: ${rem(64)};

  ${tileDesktopLayout} {
    width: ${rem(190)};
    height: 100%;
  }
`

const PrimaryContentContainer = styled(Group)`
  grid-area: primary-content;

  ${tileDesktopLayout} {
    padding: ${rem(20)} 0;
  }
`

const SecondaryContentContainer = styled(Group)`
  grid-area: secondary-content;
  
  ${tileDesktopLayout} {
    padding: ${rem(20)};
  }
`

function LoadingCartReviewTileSkeleton() {
  return (
    <CartReviewTileBase banner={undefined} showOverlay={false} layout="with-image">
      <Image data-testid="cart-tile-loading-box" />
      <PrimaryContentContainer direction="vertical" gap={12}>
        <Group direction="vertical" gap={4}>
          <TextLoadingBox typography="body-medium" lines={2} width="30ch" />
          <TextLoadingBox typography="body-medium" lines={3} width="16ch" />
        </Group>
      </PrimaryContentContainer>
      <SecondaryContentContainer direction="vertical-reverse" tabletDirection="vertical" verticalAlign="space-between" gap={24}>
        <Group direction="horizontal" gap={4}>
          <TextLoadingBox typography="heading3" width="4ch" />
          <TextLoadingBox typography="heading3" width="4ch" />
        </Group>
        <Group direction="vertical" gap={2} verticalAlign="end" horizontalAlign="start" tabletHorizontalAlign="end">
          <TextLoadingBox typography="body-medium" width="12ch" />
          <TextLoadingBox typography="body-small" width="14ch" />
        </Group>
      </SecondaryContentContainer>
    </CartReviewTileBase>
  )
}

export default LoadingCartReviewTileSkeleton
